module.exports = __webpack_public_path__ + "static/img/8.bafe20c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/7/1/sp/8.png
// module id = HmK1
// module chunks = 0